import NotificationsOptionsModalView from "./notificationsOptionsModal.html";
import NotificationsModalMailView from "./notificationsModalMail.html";


angular.module('notifications')

    .controller("NotificationsTemplateModalCtrl", ['eventId', 'guestsIds', 'staffsIds', 'personsIds', 'usersIds', 'mailAccountId', 'mailAccountReply', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', 'logService',
        function (eventId, guestsIds, staffsIds, personsIds, usersIds, mailAccountId, mailAccountReply, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, logService) {

        Restangular.all('NotificationsTemplates').customGET("LoadTemplatesForSelect").then(function (templates) {
            $scope.templates = templates;
        });

        $scope.createFromTemplate = function (template) {
            logService.debug(template);
            let $modalInstance = $uibModal.open({
                animation: true,
                template: NotificationsOptionsModalView,
                size: "lg",
                controller: "NotificationsOptionsModalCtrl",
                resolve: {
                    eventId: function () {
                        return eventId;
                    },
                    guestsIds: function () {
                        return guestsIds;
                    },
                    staffsIds: function () {
                        return staffsIds;
                    },
                    personsIds: function () {
                        return personsIds;
                    },
                    usersIds: function () {
                        return usersIds;
                    },
                    mailAccountId: function () {
                        return mailAccountId;
                    },
                    mailAccountReply: function () {
                        return mailAccountReply;
                    },
                    template: function () {
                        return template;
                    }
                }
            });
            //Response del modal
            $modalInstance.result.then(function (id) {
                $uibModalInstance.close(true);
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
            });
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }])

    .controller('NotificationsOptionsModalCtrl', ['template', 'eventId', 'guestsIds', 'staffsIds', 'personsIds', 'usersIds', 'mailAccountId', 'mailAccountReply', '$scope', '$uibModalInstance', '$http', 'Restangular', 'LoginService', '$uibModal', '$filter', 'logService',
        function (template, eventId, guestsIds, staffsIds, personsIds, usersIds, mailAccountId, mailAccountReply, $scope, $uibModalInstance, $http, Restangular, LoginService, $uibModal, $filter, logService) {

        $scope.selected = [];
        var user_mail = "";

        let option = { _sortBy: "FK_documents_documents_types.code"};
        Restangular.all('Documents').getList(option).then(function (documents) {
            //$scope.documents = documents;
            $scope.documents = [];
            angular.forEach(documents, function (item) {
                if (guestsIds != null && guestsIds.length > 0) {
                    if (item.FK_documents_documents_types.code == "INVITATION" ||
                        //item.FK_documents_documents_types.code == "ELECTRONIC_INVITATION" || //no los incluimos, se duplican las de invitaciones normales
                        item.FK_documents_documents_types.code == "GUEST_PARKING" ||
                        //item.FK_documents_documents_types.code == "GUEST_LOCATION" ||
                        item.FK_documents_documents_types.code == "EVENT_MENU" ||
                        item.FK_documents_documents_types.code == "GUEST_ZONE" ||
                        item.FK_documents_documents_types.code == "PROGRAM_ACTS" ||
                        item.FK_documents_documents_types.code == "GUEST_ACCREDITATION") {
                        $scope.documents.push(item);
                    }
                } else {
                    if (item.FK_documents_documents_types.code == "EVENT_MENU" ||
                        item.FK_documents_documents_types.code == "PROGRAM_ACTS" ||
                        item.FK_documents_documents_types.code == "PROPOSAL_GUEST_LIST" ||
                        item.FK_documents_documents_types.code == "GUEST_LIST" ||
                        item.FK_documents_documents_types.code == "SPACE_GUESTS" ||
                        item.FK_documents_documents_types.code == "SPACE_FULL_PLAN" ||
                        item.FK_documents_documents_types.code == "GUEST_LIST_ADDRESSES") {
                        $scope.documents.push(item);
                    }
                }
            });
        });

        $scope.setValue = function (document_type_id, document_type_code, document_id) {
            $scope.selected[document_type_id].document_id = document_id;
            $scope.selected[document_type_id].document_type_code = document_type_code;
        };
        
        $scope.save = function () {
            $scope.options = { to: "", content: "", subject: "", cc: [], cco: [], invitation_template: "", program_template: "", parking_template: "", zone_template: "", menu_template: "", guest_location_template: "", template_id: null };

            angular.forEach($scope.selected, function (item) {
                if (item.checked) {
                    if (item.document_type_code == "PROGRAM_ACTS") {
                        $scope.options.program_template = item.document_id;
                    } else if (item.document_type_code == "INVITATION" || item.document_type_code == "ELECTRONIC_INVITATION") {
                        $scope.options.invitation_template = item.document_id;
                    } else if (item.document_type_code == "GUEST_PARKING") {
                        $scope.options.parking_template = item.document_id;
                    } else if (item.document_type_code == "GUEST_LOCATION") {
                        $scope.options.guest_location_template = item.document_id;
                    } else if (item.document_type_code == "EVENT_MENU") {
                        $scope.options.menu_template = item.document_id;
                    } else if (item.document_type_code == "GUEST_ZONE") {
                        $scope.options.zone_template = item.document_id;
                    } else if (item.document_type_code == "GUEST_LIST") {
                        $scope.options.list_guests_template = item.document_id;
                    } else if (item.document_type_code == "PROPOSAL_GUEST_LIST") {
                        $scope.options.list_guests_proposal_template = item.document_id;
                    } else if (item.document_type_code == "GUEST_LIST_ADDRESSES") {
                        $scope.options.guest_addresses_template = item.document_id;
                    } else if (item.document_type_code == "SPACE_GUESTS") {
                        $scope.options.guests_space_plan_template = item.document_id;
                    } else if (item.document_type_code == "SPACE_FULL_PLAN") {
                        $scope.options.full_space_plan_template = item.document_id;
                    } else if (item.document_type_code == "GUEST_ACCREDITATION") {
                        $scope.options.accreditation_template = item.document_id;
                    }
                }
            });

            //ponemos contenido de plantilla del idioma
            if (angular.isDefined(template) && template != null && angular.isDefined(template.FK_templates_tl_templates) && template.FK_templates_tl_templates.length > 0) {

                if (eventId != null && eventId != "" && template.FK_templates_tl_templates[0].id != null && template.FK_templates_tl_templates[0].id != "") {
                    Restangular.all("NotificationsTemplates").customGET("LoadTemplateFromEmailsFromEvent", { event_id: eventId, template_tl_id: template.FK_templates_tl_templates[0].id }).then(function (res) {
                        if (res.content !== "" && typeof (res.content) !== "undefined") {                            //Es que ya se ha mandado el correo alguna vez y se precarga ese como el template.
                            $scope.options.content = res.content;
                        } else {
                            $scope.options.content = template.FK_templates_tl_templates[0].html;
                        }
                        $scope.options.template_id = template.FK_templates_tl_templates[0].id;
                        $scope.endLoadTemplate();
                    });
                } else {
                    $scope.options.content = template.FK_templates_tl_templates[0].html;
                    $scope.options.template_id = template.FK_templates_tl_templates[0].id;
                    logService.debug($scope.options.content);
                    $scope.endLoadTemplate();
                }
            } else {
                $scope.endLoadTemplate();
            }
        };

        $scope.endLoadTemplate = function () {

            //Dependiendo de la seleccion, iremos creando los campos correspondientes.            
            $scope.mail = {
                addresses: $scope.options.to,
                content: $scope.options.content,
                subject: $scope.options.subject,
                module: "",
                code: "",
                cc: [],
                cco: [],
                cc_tmp: $scope.options.cc,
                cco_tmp: $scope.options.cco,
                mail_account_id: mailAccountId,
                mail_account_reply: mailAccountReply,
                message: "",
                files: [],
                attachments: [],
                event_id: eventId,
                event_guests_ids: guestsIds,
                persons_ids: personsIds,
                users_ids: (eventId != null ? null : usersIds),
                event_staffs_ids: staffsIds,
                event_users_ids: (eventId != null ? usersIds : null),
                invitation_template: $scope.options.invitation_template,
                program_template: $scope.options.program_template,
                parking_template: $scope.options.parking_template,
                zone_template: $scope.options.zone_template,
                menu_template: $scope.options.menu_template,
                accreditation_template: $scope.options.accreditation_template,
                list_guests_template: $scope.options.list_guests_template,
                guest_location_template: $scope.options.guest_location_template,
                full_space_plan_template: $scope.options.full_space_plan_template,
                guests_space_plan_template: $scope.options.guests_space_plan_template,
                guest_addresses_template: $scope.options.guest_addresses_template,
                list_guests_proposal_template: $scope.options.list_guests_proposal_template,
                template_id: $scope.options.template_id,
                template: template
            };

            let $modalInstance = $uibModal.open({
                animation: true,
                template: NotificationsModalMailView,
                controller: 'NotificationsModalMailCtrl',
                size: 'lg',
                resolve: {
                    options: function () { return $scope.mail; }
                }
            });

            $modalInstance.result.then(function (bool) {
                toastr.success($filter('translate')('notifications.sending_mail_success'));
                $uibModalInstance.close(true);
            });
            
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
    

;